import { Command, deepCopy } from "@rauricoste/core";

export type UndoState = {
  playerIds: string[];
  answers: Record<string, boolean>;
  justReverted?: boolean;
};

export const undoApiFactory = (state: UndoState, playerId: string) => {
  const { playerIds } = state;
  const privateApi = {
    askUndo(): UndoState {
      return privateApi.answerUndo({ isOk: true });
    },
    answerUndo({ isOk }: { isOk: boolean }): UndoState {
      const newAnswers = deepCopy(state.answers);
      newAnswers[playerId] = isOk;
      return { playerIds, answers: newAnswers };
    },
  };
  const { askUndo, answerUndo } = privateApi;
  return { askUndo, answerUndo };
};

export const emptyUndoCommandApi = undoApiFactory(
  {
    playerIds: [],
    answers: {},
  },
  ""
);

export const undoCommandBuilder = Command.builder(emptyUndoCommandApi);

export type UndoApi = typeof emptyUndoCommandApi;
export type UndoCommand = Command<UndoApi>;

export const getUndoCommandArg = <Key extends keyof UndoApi>(
  command: UndoCommand
) => command.arg as Command<UndoApi, Key>["arg"];
